import { render, staticRenderFns } from "./payTypeSetting.vue?vue&type=template&id=c98422f8&scoped=true"
import script from "./payTypeSetting.vue?vue&type=script&lang=js"
export * from "./payTypeSetting.vue?vue&type=script&lang=js"
import style0 from "./payTypeSetting.vue?vue&type=style&index=0&id=c98422f8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c98422f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c98422f8')) {
      api.createRecord('c98422f8', component.options)
    } else {
      api.reload('c98422f8', component.options)
    }
    module.hot.accept("./payTypeSetting.vue?vue&type=template&id=c98422f8&scoped=true", function () {
      api.rerender('c98422f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shopManage/children/payTypeSetting.vue"
export default component.exports